/**
 * @generated SignedSource<<60aa147989840fe5b5d64559b8309d0d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBlurbDesignYourOwn_viewer$data = {
  readonly isDyoEnabled: boolean | null;
  readonly " $fragmentType": "PdpSharedBlurbDesignYourOwn_viewer";
};
export type PdpSharedBlurbDesignYourOwn_viewer$key = {
  readonly " $data"?: PdpSharedBlurbDesignYourOwn_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBlurbDesignYourOwn_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedBlurbDesignYourOwn_viewer",
  "selections": [
    {
      "alias": "isDyoEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "designYourOwn"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"designYourOwn\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "ad7a7b56b89919263fd627d7630e9641";

export default node;
